'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _redux = require('redux');

var _finalsReducer = require('./finals/reducer');

var _finalsReducer2 = _interopRequireDefault(_finalsReducer);

var _fixtures = require('./fixtures');

var _tournaments = require('./tournaments');

var _teams = require('./teams');

exports['default'] = _redux.combineReducers({
  finals: _finalsReducer2['default'],
  fixtures: _fixtures.reducer,
  tournaments: _tournaments.reducer,
  teams: _teams.reducer
});
module.exports = exports['default'];